/**
 * Decoder/Encoder Constants
 * All available operations and their metadata
 */

import type { DecoderOperation } from './types';

export const DECODER_OPERATIONS: Record<string, DecoderOperation> = {
  'url-decode': {
    type: 'url-decode',
    label: 'URL Decode',
    description: 'Decode URL-encoded text (%20 → space)',
    category: 'decode',
  },
  'url-encode': {
    type: 'url-encode',
    label: 'URL Encode',
    description: 'Encode text for URLs (space → %20)',
    category: 'encode',
  },
  'base64-decode': {
    type: 'base64-decode',
    label: 'Base64 Decode',
    description: 'Decode Base64-encoded text',
    category: 'decode',
  },
  'base64-encode': {
    type: 'base64-encode',
    label: 'Base64 Encode',
    description: 'Encode text to Base64',
    category: 'encode',
  },
  'hex-decode': {
    type: 'hex-decode',
    label: 'Hex Decode',
    description: 'Decode hexadecimal to ASCII',
    category: 'decode',
  },
  'hex-encode': {
    type: 'hex-encode',
    label: 'Hex Encode',
    description: 'Encode ASCII to hexadecimal',
    category: 'encode',
  },
  'html-decode': {
    type: 'html-decode',
    label: 'HTML Decode',
    description: 'Decode HTML entities (&lt; → <)',
    category: 'decode',
  },
  'html-encode': {
    type: 'html-encode',
    label: 'HTML Encode',
    description: 'Encode special characters to HTML entities',
    category: 'encode',
  },
  'unicode-decode': {
    type: 'unicode-decode',
    label: 'Unicode Decode',
    description: 'Decode Unicode escape sequences (\\u0048 → H)',
    category: 'decode',
  },
  'unicode-encode': {
    type: 'unicode-encode',
    label: 'Unicode Encode',
    description: 'Encode to Unicode escape sequences',
    category: 'encode',
  },
  'jwt-decode': {
    type: 'jwt-decode',
    label: 'JWT Decode',
    description: 'Decode JSON Web Token (header + payload)',
    category: 'decode',
  },
  'json-pretty': {
    type: 'json-pretty',
    label: 'JSON Pretty Print',
    description: 'Format JSON with indentation',
    category: 'format',
  },
  'json-minify': {
    type: 'json-minify',
    label: 'JSON Minify',
    description: 'Remove whitespace from JSON',
    category: 'format',
  },
  'hash-sha1': {
    type: 'hash-sha1',
    label: 'SHA-1 Hash',
    description: 'Generate SHA-1 hash',
    category: 'hash',
  },
  'hash-sha256': {
    type: 'hash-sha256',
    label: 'SHA-256 Hash',
    description: 'Generate SHA-256 hash',
    category: 'hash',
  },
  'hash-sha512': {
    type: 'hash-sha512',
    label: 'SHA-512 Hash',
    description: 'Generate SHA-512 hash',
    category: 'hash',
  },
  'smart-decode': {
    type: 'smart-decode',
    label: 'Smart Decode',
    description: 'Auto-detect and decode common encodings',
    category: 'smart',
  },
};

export const OPERATION_CATEGORIES = {
  decode: 'Decode',
  encode: 'Encode',
  hash: 'Hash',
  format: 'Format',
  smart: 'Smart',
} as const;

export const DECODER_SHORTCUTS = {
  TOGGLE: 'mod+d',
  APPLY: 'mod+enter',
  CLEAR: 'mod+k',
  CLOSE: 'escape',
} as const;
